var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-radio-group",
        {
          staticStyle: { margin: "0" },
          attrs: { size: "mini" },
          model: {
            value: _vm.selectedOilCode,
            callback: function($$v) {
              _vm.selectedOilCode = $$v
            },
            expression: "selectedOilCode"
          }
        },
        [
          _c("el-radio", { attrs: { border: "", label: "999" } }, [
            _vm._v("所有")
          ]),
          _c("el-radio", { attrs: { border: "", label: "92" } }, [
            _vm._v("92#汽油")
          ]),
          _c("el-radio", { attrs: { border: "", label: "95" } }, [
            _vm._v("95#汽油")
          ]),
          _c("el-radio", { attrs: { border: "", label: "0" } }, [
            _vm._v(" 0#柴油")
          ])
        ],
        1
      ),
      _c("el-switch", {
        staticStyle: { display: "block", width: "10rem", margin: "0.5rem 0" },
        attrs: {
          "active-color": "#13ce66",
          "inactive-color": "#13ce66",
          "active-text": "订单",
          "inactive-text": "销量"
        },
        model: {
          value: _vm.switchValue,
          callback: function($$v) {
            _vm.switchValue = $$v
          },
          expression: "switchValue"
        }
      }),
      _c(
        "el-table",
        {
          ref: "tableStationSoldDistribution" + _vm.sheetType,
          attrs: {
            data: _vm.getDistributionTypeData(
              _vm.renderData,
              !_vm.switchValue ? 1 : 2
            ),
            "highlight-current-row": "",
            height: "700",
            "summary-method": _vm.getSummaries,
            "show-summary": "",
            "cell-style": _vm.cellStyle,
            "header-cell-style": { "text-align": "center" },
            border: ""
          },
          on: { "filter-change": _vm.filterChange }
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              label: _vm.selectedArea,
              align: "center",
              "column-key": "area",
              filters: _vm.filterMapping,
              "filter-multiple": false,
              "filter-placement": "right",
              "filter-method": _vm.filterHandler
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.sellerName(scope.row.stationId)) + " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: "合计",
              width: "100px",
              align: "center",
              prop: "total"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.npPlus(
                            scope.row.data0,
                            scope.row.data1,
                            scope.row.data2,
                            scope.row.data3,
                            scope.row.data4,
                            scope.row.data5,
                            scope.row.data6,
                            scope.row.data7,
                            scope.row.data8,
                            scope.row.data9,
                            scope.row.data10,
                            scope.row.data11,
                            scope.row.data12,
                            scope.row.data13,
                            scope.row.data14,
                            scope.row.data15,
                            scope.row.data16,
                            scope.row.data17,
                            scope.row.data18,
                            scope.row.data19,
                            scope.row.data20,
                            scope.row.data21,
                            scope.row.data22,
                            scope.row.data23
                          )
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c(
            "el-table-column",
            { attrs: { label: "A班", align: "center" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: "A班小计",
                  width: "100px",
                  align: "center",
                  prop: "totalA"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.npPlus(
                                scope.row.data0,
                                scope.row.data1,
                                scope.row.data2,
                                scope.row.data3,
                                scope.row.data4,
                                scope.row.data5,
                                scope.row.data6,
                                scope.row.data7
                              )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "0~1点",
                  width: "100px",
                  align: "center",
                  prop: "data0"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "1~2点",
                  width: "100px",
                  align: "center",
                  prop: "data1"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "2~3点",
                  width: "100px",
                  align: "center",
                  prop: "data2"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "3~4点",
                  width: "100px",
                  align: "center",
                  prop: "data3"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "4~5点",
                  width: "100px",
                  align: "center",
                  prop: "data4"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "5~6点",
                  width: "100px",
                  align: "center",
                  prop: "data5"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "6~7点",
                  width: "100px",
                  align: "center",
                  prop: "data6"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "7~8点",
                  width: "100px",
                  align: "center",
                  prop: "data7"
                }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            { attrs: { label: "B班", align: "center" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: "B班小计",
                  width: "100px",
                  align: "center",
                  prop: "totalB"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.npPlus(
                                scope.row.data8,
                                scope.row.data9,
                                scope.row.data10,
                                scope.row.data11,
                                scope.row.data12,
                                scope.row.data13,
                                scope.row.data14,
                                scope.row.data15
                              )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "8~9点",
                  width: "100px",
                  align: "center",
                  prop: "data8"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "9~10点",
                  width: "100px",
                  align: "center",
                  prop: "data9"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "10~11点",
                  width: "100px",
                  align: "center",
                  prop: "data10"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "11~12点",
                  width: "100px",
                  align: "center",
                  prop: "data11"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "12~13点",
                  width: "100px",
                  align: "center",
                  prop: "data12"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "13~14点",
                  width: "100px",
                  align: "center",
                  prop: "data13"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "14~15点",
                  width: "100px",
                  align: "center",
                  prop: "data14"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "15~16点",
                  width: "100px",
                  align: "center",
                  prop: "data15"
                }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            { attrs: { label: "C班", align: "center" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: "C班小计",
                  width: "100px",
                  align: "center",
                  prop: "totalC"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.npPlus(
                                scope.row.data16,
                                scope.row.data17,
                                scope.row.data18,
                                scope.row.data19,
                                scope.row.data20,
                                scope.row.data21,
                                scope.row.data22,
                                scope.row.data23
                              )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "16~17点",
                  width: "100px",
                  align: "center",
                  prop: "data16"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "17~18点",
                  width: "100px",
                  align: "center",
                  prop: "data17"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "18~19点",
                  width: "100px",
                  align: "center",
                  prop: "data18"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "19~20点",
                  width: "100px",
                  align: "center",
                  prop: "data19"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "20~21点",
                  width: "100px",
                  align: "center",
                  prop: "data20"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "21~22点",
                  width: "100px",
                  align: "center",
                  prop: "data21"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "22~23点",
                  width: "100px",
                  align: "center",
                  prop: "data22"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "23~0点",
                  width: "100px",
                  align: "center",
                  prop: "data23"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }